module.exports = __webpack_public_path__ + "static/media/gs.bfd2809a.svg";